import { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useAuth from '../../../hooks/useAuth';
import axiosInstance from '../../../api/axios';
import dayjs from 'dayjs';
import TransactionOTPDialog from '../../../components/common/otp-input/TransactionOTPDialog';
import TransactionTable from "../table/TransactionTable";
import { notifyError, notifySuccess } from "../../../components/common/toast/ToastFunc";

const TransactionRequest = () => {

  const { user } = useAuth();

  const isMerchant = user.role === 'merchant';

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [transferLoading, setTransferLoading] = useState(false);
  const [showTransactionOTPDialog, setShowTransactionOTPDialog] = useState(false);
  const [updTrans, setUpdTrans] = useState({ id: '', update_type: '' });

  const theme = useTheme();

  const formatData = useCallback((data) => {
    try {
      const formattedData = data?.map(item => {
        return {
          ...item,
          id: item.id.replace(/-/g, ''),
          from_acc: item.transaction.from_acc.replace(/-/g, ''),
          to_acc: item.transaction.to_acc.replace(/-/g, ''),
          amount: `$ ${item.transaction.amount}`,
          created_at: dayjs(item.transaction.created_at).format('MM/DD/YYYY HH:mm:ss'), // Formatting date with dayjs
          status: item?.transaction?.status.charAt(0).toUpperCase() + item?.transaction?.status.slice(1).toLowerCase(),
          type: item?.transaction?.type.charAt(0) + item?.transaction?.type.slice(1).toLowerCase() // Capitalizing the first letter
        };
      });
      setData(formattedData);
    } catch (error) {
      notifyError("Something went wrong");
    }
  }, []);

  const updateOTPDialog = useCallback((rev_id, type) => {
    setUpdTrans({ id: rev_id, update_type: type });
    setShowTransactionOTPDialog(true);
  }, []);

  const updateTransaction = useCallback(async (otp, otp_source) => {
    try {
      setTransferLoading(true);
      const response = await axiosInstance.post('/transaction/update-collect-request', {
        id: updTrans.id,
        update_type: updTrans.update_type,
        "otp": otp,
        "otp_source": otp_source
      });
      notifySuccess(response?.data?.message || "Success");
      setShowTransactionOTPDialog(false);
      setUpdTrans({ id: '', update_type: '' });
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setTransferLoading(false);
    }
  }, [reFetch, setTransferLoading, setReFetch, updTrans]);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get('/transaction/collect-request');
        formatData(response.data.data);
      } catch (error) {
        notifyError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [formatData, reFetch]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", my: 3 }}>
      {showTransactionOTPDialog && <TransactionOTPDialog onVerified={updateTransaction} transferLoading={transferLoading} setTransferLoading={setTransferLoading} showTransactionOTPDialog={showTransactionOTPDialog} setShowTransactionOTPDialog={setShowTransactionOTPDialog} otpSource={"Transaction"} />}
      <Typography variant="h5" sx={{ mb: 2, color: theme.mainColor }}>Transaction Request</Typography>
      <TransactionTable
        data={data}
        setData={setData}
        loading={loading}
        setReFetch={setReFetch}
        updateTransaction={updateTransaction}
        transferLoading={transferLoading}
        isCustomerTransactionRequest={true}
        isMerchantTransactionRequest={isMerchant}
        updateOTPDialog={updateOTPDialog}
      />
    </Box>
  );
};

export default TransactionRequest;
